function prepareFormTracking (detail) {
    switch(typeof detail) {
        case "string":
            sessionStorage.setItem("formToTrack", JSON.stringify({
                "kunden_anfrage": detail
            }));
            break;
        case "object":
            sessionStorage.setItem("formToTrack", JSON.stringify(detail));
            break;
        default:
    }
}

function trackPreparedForm () {
    if(typeof dataLayer !== "undefined") {
        var data = sessionStorage.getItem("formToTrack");
        if(data) {
            try {
                data = JSON.parse(data);
                data["event"] = "form_submit";
                dataLayer.push(data);
            } catch(e) { }
            sessionStorage.removeItem("formToTrack");
        }
    }
}